export const excludedFieldName = ['isDeleted'];

export const excludedFieldType = ['isDeleted'];
export const excludedFieldNameSort = ['isDeleted', 'createdBy'];
export const excludedFieldTypeSort = [
  // 'createdAt',
  'password',
  'file',
  'reference',
  'image',
  'multi_image',
  'video_link',
  // 'updatedAt',
  'isDeleted',
  'dynamic_option',
  'static_option',
];
export const primaryQueries = [
  { value: 'FIND', label: 'Find First Matching Data' },
  { value: 'FIND_ALL', label: 'Find All Matching Data' },
  { value: 'COUNT', label: 'Count' },
  { value: 'AVG', label: 'Average' },
  { value: 'SUM', label: 'Sum' },
  { value: 'MAX', label: 'Max' },
  { value: 'MIN', label: 'Min' },
];

export const referenceTypeArray = ['dynamic_option', 'reference', 'belongsTo', 'belongsto'];

export const EQUALS = 'EQUALS';
export const IS_NOT_NULL = 'IS_NOT_NULL';
export const IS_NULL = 'IS_NULL';
export const LIKE = 'LIKE';
export const IN_LIST = 'IN_LIST';
export const NOT_IN_LIST = 'NOT_IN_LIST';
export const LESS_THAN = 'LESS_THAN';
export const GREATER_THAN = 'GREATER_THAN';
export const LESS_THAN_EQUALS_TO = 'LESS_THAN_EQUALS_TO';
export const GREATER_THAN_EQUALS_TO = 'GREATER_THAN_EQUALS_TO';
export const BETWEEN = 'BETWEEN';
export const NOT_EQUAL = 'NOT_EQUAL';
export const CURRENT_TIME = 'CURRENT_TIME';
export const CURRENT_DATE = 'CURRENT_DATE';
export const CURRENT_DATE_TIME = 'CURRENT_DATE_TIME';
export const HOUR = 'HOUR';
export const DAY = 'DAY';
export const WEEK = 'WEEK';
export const MONTH = 'MONTH';
export const YEAR = 'YEAR';
export const DateTimeUnit = [HOUR, DAY, WEEK, MONTH, YEAR];
export const CURRENT_MONTH = 'CURRENT_MONTH';
export const CURRENT_YEAR = 'CURRENT_YEAR';
export const EQUALS_OR_IGNORE = 'EQUALS_OR_IGNORE';
